import Query from './parse-query.js'

export function updateSessionStorage () {
  //tracking external links to grenke website with source param
  //eloqua init and contact detail init will try to copy this  campaign code to an input field.
  if (window.location.search) {
    let queryString = (window.location.search).split('?')[1]
    let queryParams = Query.parseQuery(queryString)

    if (queryParams.source) {
      sessionStorage.setItem('source', queryParams.source)
    }
  }
}
